import { Component, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'phx-button-group',
    template: `<ng-content></ng-content>`,
    styleUrls: ['./phx-button-group.component.scss'],
    host: {
        class: 'phx-button-group',
    },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxButtonGroupComponent { }
